import React, { Fragment } from "react";
import {
  Container,
  IconButton,
  Dialog,
  DialogContent,
  CircularProgress,
} from "@mui/material";
import {
  bannerStyles,
  dialogContentStyles,
  expandIcon,
  iconButtonStyles,
  imageStyles,
} from "../enums/BannerStyles";
import { AspectRatio, CloseOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import useBanner from "../hooks/useBanner";

export default function Banner() {
  const { t } = useTranslation();
  const banner = useBanner();
  const [openDialog, setOpenDialog] = React.useState(false);

  function handleShowImage() {
    setOpenDialog(!openDialog);
  }

  if (banner) {
    return (
      <div>
        <Fragment>
          <Container sx={bannerStyles}>
            <IconButton
              sx={expandIcon}
              aria-label={t("ExpandImage")}
              title={t("ExpandImage")}
              onClick={handleShowImage}
            >
              <AspectRatio />
            </IconButton>
            <div style={imageStyles(banner)} />
          </Container>

          <Dialog
            fullWidth
            maxWidth="lg"
            open={openDialog}
            onClose={handleShowImage}
            PaperProps={{
              style: {
                backgroundColor: "transparent",
                boxShadow: "none",
              },
            }}
          >
            <DialogContent sx={dialogContentStyles}>
              <IconButton onClick={handleShowImage} sx={iconButtonStyles} title={t("Close")}>
                <CloseOutlined />
              </IconButton>

              {banner ? (
                <img
                  src={banner}
                  alt="Expanded view"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    borderRadius: "10px",
                  }}
                />
              ) : (
                <CircularProgress />
              )}
            </DialogContent>
          </Dialog>
        </Fragment>
      </div>
    );
  }
}
